/** Decorative orbit motif derived from the ADCS logo. */
export function OrbitMotif() {
  return (
    <svg
      viewBox="40 100 440 312"
      width={440}
      height={312}
      className="orbit-rings"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="orbitStroke" x1="6%" y1="92%" x2="94%" y2="8%">
          <stop offset="0%" stopColor="#0E5C86" />
          <stop offset="52%" stopColor="#0080B0" />
          <stop offset="100%" stopColor="#00B4E7" />
        </linearGradient>
      </defs>

      <g fill="none" strokeLinecap="round">
        <g transform="rotate(-28 260 260)">
          {/* Concentric shells: engineering-drawing weight. */}
          <ellipse cx={260} cy={260} rx={232} ry={106} stroke="#012247" strokeOpacity={0.2} strokeWidth={1.1} />
          <ellipse cx={260} cy={260} rx={132} ry={60} stroke="#012247" strokeOpacity={0.28} strokeWidth={1.1} strokeDasharray="3 7" />

          {/* Primary orbit: the one element carrying brand cyan. */}
          <ellipse cx={260} cy={260} rx={210} ry={96} stroke="url(#orbitStroke)" strokeWidth={3.2} />

          {/* The travelling node is a separate layer — see OrbitNode. */}

          <circle cx={78.1} cy={308} r={4.5} fill="#012247" fillOpacity={0.45} stroke="none" />
        </g>

        {/* Centre datum. */}
        <g stroke="#012247" strokeOpacity={0.34} strokeWidth={1.1}>
          <circle cx={260} cy={260} r={4.5} />
          <path d="M260 238v-13M260 282v13M238 260h-13M282 260h13" />
        </g>
      </g>
    </svg>
  );
}
